"use client";
import Button from "src/app/components/ui/Button";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";

const Banner = () => {
  const { data } = useFetchCompanyInfo();
  return (
    <div className="wrapper relative z-[20] -bottom-[3.5rem]">
      <div className="item relative z-[20] rounded-2xl border-2 border-themeColor  bg-white">
        <div className="bg-[rgba(var(--primary-color-rgb),0.1)]   text-secondary-main p-10 xlg:flex-col xlg:gap-6  mx-auto flex items-center justify-between shadow-lg">
          <div className="max-w-2xl z-[20]">
            <h2 className="h5 text-themeColor !font-bold">
              Buying or Selling? Trust Us to Lead the Way!
            </h2>
            <p className="mt-2">
              Need expert property management, quick property sales, rentals, or
              short-let services? {data?.companyInfo?.name} is your trusted
              partner for all-encompassing real estate solutions, providing
              everything you require in one place.
            </p>
          </div>

          <Count count={data?.companyStat?.completed_transaction || 0} />
          <Button
            href="/contact"
            className="mt-4 md:h-max primary-btn whitespace-nowrap !px-3"
          >
            Get In Touch
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Banner;

// Add this at the top since we're using client-side features like useEffect

import { useEffect, useRef, useState } from "react";

const Count: React.FC<{ count: number }> = ({ count }) => {
  const [currentCount, setCurrentCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        setCurrentCount(0); // Reset count to 0 before starting animation
        animateCount();
      }
    };

    observer.current = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // Trigger when 50% is in view
    });

    if (ref.current) {
      observer.current.observe(ref.current);
    }

    return () => observer.current?.disconnect();
  }, [count]); // React to count changes

  const animateCount = () => {
    let start = 0;
    const increment = Math.ceil(count / 100); // Adjust speed based on number
    const interval = setInterval(() => {
      start += increment;
      if (start >= count) {
        setCurrentCount(count);
        clearInterval(interval);
      } else {
        setCurrentCount(start);
      }
    }, 20); // Adjust animation speed
  };

  const digits = currentCount.toString().padStart(5, "0").split("");

  return (
    <div ref={ref} className="flex flex-col items-center gap-2">
      <div className="flex gap-2">
        {digits.map((digit, index) => (
          <Number number={digit} key={index} />
        ))}
      </div>
      <h5>Successful Deals</h5>
    </div>
  );
};

const Number: React.FC<{ number: string }> = ({ number }) => {
  return (
    <h4 className="bg-themeColor rounded-xl text-white font-bold text-5xl p-2">
      {number}
    </h4>
  );
};

// // Banner component remains the same but needs "use client" at the top of its file
// // since it uses the Count component which is now client-side
// const Number: React.FC<{ number: string }> = ({ number }) => {
//   return (
//     <div className="bg-themeColor rounded-xl text-white font-bold text-5xl p-2">
//       {number}
//     </div>
//   );
// };
